<div class="rangebox">
    <button data-target="#collapseType" data-toggle="collapse" class="collapsebtn" type="button">Fare Type</button>
    
    
        <div id="collapseType" class="collapse show">
            <div class="boxins">
                <ul class="locationul">
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="typecheckbox" id="squaredThree3">
                            <label for="squaredThree3"></label>
                        </div>
                        <label class="llbl" for="squaredThree3">Private Fare</label>
                    </li>
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="typecheckbox" id="squaredThree4">
                            <label for="squaredThree4"></label>
                        </div>
                        <label class="llbl" for="squaredThree4">Published Fare</label>
                    </li>
                    
              </ul>
            </div>
        </div>
    
</div>

